export class BadRequestError extends Error {
    constructor() {
        super('Missing or invalid required fields.');
    }
}
